<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0 ff-robo" style="text-align: justify;">Copyright &COPY; {{year}} ELT&commat;I. All rights reserved.
      </p>
    </div>
    <div class="col-md-6">
      <p class="pull-right mb-0 ff-robo">Designed & Developed by <a href="https://www.deemsys.ai/"
          target="_blank">Deemsys</a></p>
    </div>
  </div>
</div>